import * as React from "react";
import ResponsiveImage from "~/components/responsive-image/responsive-image";
import { IBaseLink } from "~/types/link";

export interface INavigationSpotProps extends IBaseLink {
    imgTitle: string;
    imgAlt: string;
    imgSrc: string;
}

const NavigationSpot: React.SFC<INavigationSpotProps> = props => {
    return (
        <div className="navigation-spot">
            <div className="navigation-spot__content">
                <a href={props.url} target={props.target}>
                    <ResponsiveImage
                        className="navigation-spot__img"
                        srcUrl={props.imgSrc}
                        alt={props.imgAlt}
                        title={props.imgTitle}
                        sizes="(max-width: 1366px) calc((100vw - 64px) / 2), 650px"
                        srcSetSizes={[480, 550, 600, 650]}
                        defaultSize={650}
                    />
                </a>
            </div>
        </div>
    );
};

export default NavigationSpot;
